module.exports = __webpack_public_path__ + "36e4e84eb87b7c8e875d21d277166ee9.svg";